var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import MuiButton from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
var CssButton = withStyles(function () { return ({
    root: {
        height: 48,
        fontWeight: 'bold',
        fontSize: 14,
        borderRadius: 100,
        boxShadow: 'none',
        '&.MuiButton-contained': {
            '&:hover': {
                boxShadow: 'none',
            },
        },
    },
}); })(MuiButton);
var Button = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(CssButton, __assign({}, props), children));
};
export default Button;
//# sourceMappingURL=Button.js.map